import {
  TASK_VEHICLE_LIST, TASK_VEHICLE_LIST_SUCCESS, TASK_VEHICLE_LIST_ERROR,
  TASK_VEHICLE_PAGE_SET,
  TASK_VEHICLE_ADD, TASK_VEHICLE_ADD_SUCCESS, TASK_VEHICLE_ADD_ERROR,
  TASK_VEHICLE_ADD_CHANGE,
  TASK_VEHICLE_DETAIL, TASK_VEHICLE_DETAIL_SUCCESS, TASK_VEHICLE_DETAIL_ERROR,
  TASK_VEHICLE_UPDATE, TASK_VEHICLE_UPDATE_SUCCESS, TASK_VEHICLE_UPDATE_ERROR,
  TASK_VEHICLE_FILTER_VEHICLES_SUCCESS,
} from '../../actions';

const INIT_STATE = {
  loading: true,
  list: { header: { name: 'id_task_vehicle', order: 'sorted-asc' }, page: { current: 1, rows: 1000 }, data: [], total_pages: 1 },
  detail: { loading: false, data: null },
  add: { data: { new: { id_task: '', id_vehicle: '' } }, loading: false, message: '' },
  edit: { update: { loading: false, response: '', message: '' } },
  filters: { vehicles: [] },
  error: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case TASK_VEHICLE_LIST: return { ...state, loading: true };
    case TASK_VEHICLE_LIST_SUCCESS: return { ...state, loading: false, list: { ...state.list, ...action.payload } };
    case TASK_VEHICLE_LIST_ERROR: return { ...state, loading: false, error: true };
    case TASK_VEHICLE_PAGE_SET: return { ...state, list: { ...state.list, page: { ...state.list.page, ...action.payload } } };
    case TASK_VEHICLE_ADD_CHANGE: return { ...state, add: { ...state.add, data: { ...state.add.data, new: { ...state.add.data.new, ...action.payload } } } };
    case TASK_VEHICLE_ADD: return { ...state, add: { ...state.add, loading: true } };
    case TASK_VEHICLE_ADD_SUCCESS: return { ...state, add: { ...state.add, loading: false, message: action.payload.message, data: { new: { id_task: '', id_vehicle: '' } } } };
    case TASK_VEHICLE_ADD_ERROR: return { ...state, add: { ...state.add, loading: false, message: action.payload.message } };
    case TASK_VEHICLE_DETAIL: return { ...state, detail: { ...state.detail, loading: true } };
    case TASK_VEHICLE_DETAIL_SUCCESS: return { ...state, detail: { loading: false, data: action.payload } };
    case TASK_VEHICLE_DETAIL_ERROR: return { ...state, detail: { loading: false, data: null } };
    case TASK_VEHICLE_UPDATE: return { ...state, edit: { ...state.edit, update: { loading: true, response: '', message: '' } } };
    case TASK_VEHICLE_UPDATE_SUCCESS: return { ...state, edit: { ...state.edit, update: { loading: false, response: 'success', message: action.payload } } };
    case TASK_VEHICLE_UPDATE_ERROR: return { ...state, edit: { ...state.edit, update: { loading: false, response: 'error', message: action.payload } } };
    case TASK_VEHICLE_FILTER_VEHICLES_SUCCESS: return { ...state, filters: { ...state.filters, vehicles: action.payload } };
    default: return { ...state };
  }
};
